@if (apartmentFacade.isLoading$ | async) {
  <div class="bg-white px-4 rounded-xl shadow-sm">
    <nz-spin nzSimple></nz-spin>
  </div>
} @else {

  <nz-layout>
    <nz-content>
      @if (bookingId) {
        <nz-tabset>
          <nz-tab nzTitle="ძირითადი">
            <ng-container *ngTemplateOutlet="formContent"></ng-container>
          </nz-tab>
          <nz-tab nzTitle="ისტორია">
            <beautyapp-booking-audit-history [bookingId]="bookingId"></beautyapp-booking-audit-history>
          </nz-tab>
        </nz-tabset>
      } @else {
        <ng-container *ngTemplateOutlet="formContent"></ng-container>
      }

      <ng-template #formContent>
      <div nz-row [nzGutter]="[10, 10]">
        <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
          <form nz-form nzLayout="vertical" [formGroup]="form">
            <div nz-row [nzGutter]="[5, 5]">
              @if (!apartmentFacade.userId) {
                <div nz-col [nzSpan]="21">
                  <beautyapp-select-search
                    formControlName="userId"
                    [data]="apartmentFacade.customers$ | async"
                    label="{{ 'calendar.form.user' | translate }}"
                    placeholder="{{ 'calendar.form.user' | translate }}"
                    (onSearch)="apartmentFacade.searchCustomer($event)"
                    (selectedOption)="apartmentFacade.selectCustomer($event)"
                    prefixIcon="user"
                    valueMember="id"
                    displayMember="fullName"
                    required
                  ></beautyapp-select-search>
                </div>
                <div nz-col [nzSpan]="3">
                  <nz-space>
                    <button
                      *nzSpaceItem
                      (click)="apartmentFacade.addNewUser()"
                      type="button"
                      nz-button
                      nzType="primary"
                      nzShape="circle"
                      style="margin-top: 25px"
                    >
                      <i nz-icon nzType="user-add" nzTheme="outline"></i>
                    </button>
                  </nz-space>
                </div>
              } @else {
                @if (apartmentFacade.user) {
                  <div nz-col [nzSpan]="apartmentFacade.user.isVerified ? 21 : 18">
                    <nz-input-group
                      [nzSuffix]="inputClearTpl"
                      [nzPrefix]="prefixTemplateUser"
                    >
                      <input
                        type="text"
                        nz-input
                        [ngModel]="apartmentFacade.user.fullName"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="{{ 'calendar.form.user' | translate }}"
                      />
                    </nz-input-group>
<!--
            `birthDate` reaches here as `YYYY-MM-DD` since users.birthDate
            became a `date` column (migration 1788200000000). Before that it
            arrived as an instant the process had already resolved in its own
            timezone, which the badge refuses rather than guess from — so until
            that column changed, this surface deliberately showed nothing.
          -->
          <beautyapp-birthday-badge
            class="ml-2"
            [birthDate]="apartmentFacade.user?.birthDate"
          ></beautyapp-birthday-badge>
                    <ng-template #prefixTemplateUser>
                      @if (apartmentFacade.user.isVerified) {
                        <span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span>
                      } @else {
                        <span nz-icon nzType="user"></span>
                      }
                    </ng-template>
                    <ng-template #inputClearTpl>
                      <!-- beaut-358: hide the change-customer icon on a completed
                           (paid) booking. status === 2 = completed; the BE update()
                           rejects any change with "Allready completed", so prevent
                           the action instead of surfacing that raw English error. -->
                      @if (apartmentFacade.user?.fullName && apartmentFacade.booking?.status !== 2) {
                        <span
                          nz-icon
                          class="ant-input-clear-icon"
                          nzTheme="fill"
                          nzType="close-circle"
                          (click)="form.get('userId')?.setValue(null)"
                        ></span>
                      }
                    </ng-template>
                  </div>
                }
                <div nz-col [nzSpan]="apartmentFacade.user.isVerified ? 3 : 6">
                  <nz-space>
                    <button
                      *nzSpaceItem
                      (click)="apartmentFacade.viewUser()"
                      type="button"
                      nz-button
                      nzType="primary"
                      nzShape="circle"
                    >
                      <i nz-icon nzType="eye" nzTheme="outline"></i>
                    </button>
                    @if (!apartmentFacade.user.isVerified) {
                      <button
                        *nzSpaceItem
                        (click)="apartmentFacade.verify(apartmentFacade.user)"
                        type="button"
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        style="display: flex; align-items: center; justify-content: center"
                      >
                        <svg
                          t="1735934545574" class="cursor-pointer" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1461" width="20" height="20">
                          <path
                            d="M426.666667 725.333333 256 554.666667 316.16 494.506667 426.666667 604.586667 707.84 323.413333 768 384M512 42.666667 128 213.333333 128 469.333333C128 706.133333 291.84 927.573333 512 981.333333 732.16 927.573333 896 706.133333 896 469.333333L896 213.333333 512 42.666667Z"
                            [attr.fill]="'grey'"
                            p-id="1462"></path>
                        </svg>
                      </button>
                    }
                  </nz-space>
                </div>
                <div nz-col [nzSpan]="24">
                  <div nz-row style="margin-top: 8px">
                    <nz-tag
                      nz-col
                      [nzColor]="'#cf0000'"
                      [nz-tooltip]="'calendar.form.debt' | translate"
                    >{{ apartmentFacade.user.debt }}
                      {{ 'calendar.gel' | translate }}
                    </nz-tag>
                    <nz-tag
                      nz-col
                      [nzColor]="'#00cf72'"
                      [nz-tooltip]="'calendar.form.balance' | translate"
                    >{{ apartmentFacade.user.balance | number: '1.0-2' }}
                      {{ 'calendar.gel' | translate }}
                    </nz-tag>
                    <nz-tag
                      nz-col
                      [nzColor]="'#01beff'"
                      [nz-tooltip]="'calendar.form.minutes' | translate"
                    >{{ apartmentFacade.user.minutes }}
                      {{ 'calendar.minute' | translate }}
                    </nz-tag>
                    <nz-tag
                      nz-col
                      [nzColor]="'#f1ca0d'"
                      [nz-tooltip]="'users.column.cashback' | translate"
                    >
                      {{ apartmentFacade.user.cashback }}
                      {{ 'calendar.gel' | translate }}
                    </nz-tag>
                  </div>
                </div>
              }
              <div nz-col [nzSpan]="24">
                <ng-container *ngxPermissionsExcept="['Employee']">
                  <beautyapp-select
                    formControlName="employeeId"
                    [data]="apartmentFacade.employee$ | async"
                    label="{{ 'calendar.form.employee' | translate }}"
                    placeholder="{{ 'calendar.form.employee' | translate }}"
                    valueMember="id"
                    displayMember="fullName"
                    required
                  ></beautyapp-select>
                </ng-container>
                <label
                  nz-checkbox
                  formControlName="onUserRequest"
                  [nzValue]="true"
                  style="margin-bottom: 10px"
                >{{ 'calendar.form.userRequest' | translate }}</label
                >
              </div>

              <div nz-col [nzSpan]="24">
                <beautyapp-datepicker
                  label="{{ 'calendar.form.date' | translate }}"
                  placeholder="{{ 'calendar.form.date' | translate }}"
                  formControlName="bookingDate"
                  required
                ></beautyapp-datepicker>
              </div>
              <div nz-col [nzSpan]="12">
                <beautyapp-time-picker
                  label="{{ 'calendar.form.startingTime' | translate }}"
                  placeholder="{{ 'calendar.form.startingTime' | translate }}"
                  formControlName="startTime"
                  required
                ></beautyapp-time-picker>
              </div>
              <div nz-col [nzSpan]="12">
                <beautyapp-time-picker
                  label="{{ 'calendar.form.finishingTime' | translate }}"
                  placeholder="{{ 'calendar.form.finishingTime' | translate }}"
                  formControlName="endTime"
                  required
                ></beautyapp-time-picker>
              </div>
              @if (form.getError('dateRange')) {
                <div nz-col [nzSpan]="24" nz-typography nzType="danger">
                  {{ 'calendar.form.errors.dateRangeError' | translate }}
                </div>
              }
              <div nz-col [nzSpan]="24">
                <beautyapp-textarea
                  formControlName="description"
                  placeholder=""
                  label="{{ 'calendar.form.comment' | translate }}"
                  [rows]="5"
                ></beautyapp-textarea>
              </div>
            </div>
          </form>
        </div>
        <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 16}">
          <beautyapp-appointment-services
            [serviceStartTime]="
            apartmentFacade.endTime
              ? apartmentFacade.endTime
              : apartmentFacade.startTime
          "
            [employee]="apartmentFacade.selectedEmployee$ | async"
          ></beautyapp-appointment-services>
        </div>
      </div>
      </ng-template>
    </nz-content>
    <nz-footer>
      <div nz-row nzJustify="space-between" [nzGutter]="[10,10]">
        <form nz-col [formGroup]="form">
          <nz-space [nzWrap]="false">
            <div *nzSpaceItem style="width: 100px">
              <beautyapp-input
                label="{{ 'calendar.form.fixatedExpense' | translate }}"
                placeholder="{{ 'calendar.form.expense' | translate }}"
                type="float"
                formControlName="fixedPrice"
                [readonly]="true"
              ></beautyapp-input>
            </div>
            @if (!onlineBookingId) {
              <ng-container *ngxPermissionsExcept="['Employee']">
                <div *nzSpaceItem style="width: 180px">
                  <div nz-col [nzSpan]="24">
                    <beautyapp-select
                      label="{{ 'calendar.form.paymentMethod' | translate }}"
                      placeholder="{{
                      'calendar.form.paymentMethod' | translate
                    }}"
                      formControlName="paymentType"
                      [data]="apartmentFacade.paymentTypes"
                      valueMember="id"
                      displayMember="name"
                    ></beautyapp-select>
                  </div>
                </div>
                @if (apartmentFacade.paymentType === 5) {
                  <div *nzSpaceItem style="width: 100px">
                    <beautyapp-input
                      label="{{ 'calendar.form.balance' | translate }}"
                      placeholder="{{ 'calendar.form.balance' | translate }}"
                      type="number"
                      prefixIcon="tags"
                      formControlName="balance"
                      required
                      [max]="apartmentFacade.user.balance || 0"
                    ></beautyapp-input>
                  </div>
                }
                @if (apartmentFacade.paymentType === 5) {
                  <div *nzSpaceItem style="min-width: 180px; padding-top: 30px; white-space: nowrap">
                    {{ 'calendar.form.available' | translate }}:
                    {{ (apartmentFacade.user.balance || 0) | number: '1.0-2' }} ₾
                  </div>
                }
                @if (apartmentFacade.paymentType === 1 ||
                apartmentFacade.paymentType === 3 ||
                apartmentFacade.paymentType === 7 ||
                apartmentFacade.paymentType === 5) {
                  <div *nzSpaceItem style="width: 100px">
                    <beautyapp-input
                      label=" {{ 'calendar.form.cash' | translate }}"
                      placeholder=" {{ 'calendar.form.cash' | translate }}"
                      type="number"
                      prefixIcon="wallet"
                      formControlName="cash"
                    ></beautyapp-input>
                  </div>
                }
                @if (apartmentFacade.paymentType === 2 ||
                apartmentFacade.paymentType === 3 ||
                apartmentFacade.paymentType === 7 ||
                apartmentFacade.paymentType === 5) {
                  <div *nzSpaceItem style="width: 100px">
                    <beautyapp-input
                      label=" {{ 'calendar.form.bank' | translate }}"
                      placeholder=" {{ 'calendar.form.bank' | translate }}"
                      type="number"
                      prefixIcon="credit-card"
                      formControlName="card"
                    ></beautyapp-input>
                  </div>
                }
                @if (apartmentFacade.paymentType === 4) {
                  <div *nzSpaceItem style="width: 100px">
                    <beautyapp-input
                      label="{{ 'calendar.form.minutes' | translate }}"
                      placeholder="{{ 'calendar.form.minutes' | translate }}"
                      type="number"
                      prefixIcon="tags"
                      formControlName="minutes"
                      [max]="apartmentFacade.user.minutes || 0"
                    ></beautyapp-input>
                  </div>
                }
                @if (apartmentFacade.paymentType === 4) {
                  <div *nzSpaceItem style="min-width: 180px; padding-top: 30px; white-space: nowrap">
                    {{ 'calendar.form.available' | translate }}
                    : {{ apartmentFacade.user.minutes || 0 }}
                    {{ 'calendar.minute' | translate }}
                  </div>
                }
                <div *nzSpaceItem>
                  @if (apartmentFacade.paymentType === 6) {
                    <beautyapp-input
                      label="{{ 'calendar.form.exchange' | translate }}"
                      placeholder="{{ 'calendar.form.exchange' | translate }}"
                      type="number"
                      prefixIcon="tags"
                      formControlName="barter"
                    ></beautyapp-input>
                  }
                </div>
                @if (apartmentFacade.paymentType === 7) {
                  <div *nzSpaceItem style="width: 200px">
                    <beautyapp-input
                      label="{{ 'calendar.form.consignment' | translate }}"
                      placeholder="{{ 'calendar.form.consignment' | translate }}"
                      type="number"
                      prefixIcon="tags"
                      formControlName="consignation"
                    ></beautyapp-input>
                  </div>
                }
                <div *nzSpaceItem style="width: 200px">
                  @if (apartmentFacade.paymentType === 8) {
                    <beautyapp-input
                      label="{{ 'calendar.form.bankTransfer' | translate }}"
                      placeholder="{{ 'calendar.form.bankTransfer' | translate }}"
                      type="number"
                      prefixIcon="tags"
                      formControlName="bankTransfer"
                    ></beautyapp-input>
                  }
                </div>
              </ng-container>
            }
          </nz-space>
        </form>
        <div nz-col style="width: 220px">
          <p>
            {{ 'calendar.form.sumTotal' | translate }} :
            {{ apartmentFacade.getServiceSum$() | async | number: '.2' }}
            {{ 'calendar.form.gel' | translate }}
          </p>
        </div>
      </div>
      <div>
        @if (form.getError('totalPrice')) {
          <div nz-col [nzSpan]="24" nz-typography nzType="danger">
            {{ 'calendar.form.errors.totalPrice' | translate }}
          </div>
        }
      </div>
    </nz-footer>
  </nz-layout>
  <div *nzModalFooter nz-row nzJustify="space-between" [nzGutter]="[10,10]">
    <div nz-col [formGroup]="form">
      <nz-space [nzWrap]="true">
        @if (bookingId && apartmentFacade.status === 1) {
          <button
            *nzSpaceItem
            nz-button
            nzDanger
            type="button"
            (click)="apartmentFacade.deleteBooking()"
          >
            გაუქმება
          </button>
        }
        <ng-container *ngxPermissionsExcept="['Employee']">
          <label *nzSpaceItem nz-checkbox formControlName="isGift">{{
              'calendar.form.present' | translate
            }}</label>
        </ng-container>
        <label *nzSpaceItem nz-checkbox formControlName="sendNotification">
          {{ 'calendar.form.sendNotification' | translate }}
        </label>
      </nz-space>
    </div>
    <div nz-col>
      <nz-space>
        <button
          *nzSpaceItem
          [nzLoading]="apartmentFacade.isLoading$ | async"
          nz-button
          nzType="default"
          (click)="apartmentFacade.modalClose()"
        >
          {{ 'buttons.close' | translate }}
        </button>
        <button
          *nzSpaceItem
          [nzLoading]="apartmentFacade.isLoading$ | async"
          [disabled]="apartmentFacade.invalid || apartmentFacade.status === 2"
          nz-button
          nzType="primary"
          (click)="submit()"
        >
          {{ 'buttons.save' | translate }}
        </button>
        @if (!onlineBookingId) {
          <ng-container *ngxPermissionsExcept="['Employee']">
            <button
              *nzSpaceItem
              [nzLoading]="apartmentFacade.isLoading$ | async"
              nz-button
              nzDanger
              [disabled]="
              !apartmentFacade.checkComplete ||
              apartmentFacade.checkBookingInFuture
            "
              nz-popconfirm
              nzPopconfirmTitle="{{ 'buttons.finishPop' | translate }}"
              nzPopconfirmPlacement="top"
              (nzOnConfirm)="complete()"
            >
              {{ 'buttons.finish' | translate }}
            </button>
          </ng-container>
        }
      </nz-space>
    </div>
  </div>
}
